import { RouteType } from '../../types';
import { GetInitInfoQuery, VenueType } from '../../generated/graphql';

const checkScopePermissions = <T>(permissions: T[] | undefined, scopePermissions: T[]) => {
    if (permissions && permissions.length > 0) {
        return permissions
            .every(permission => scopePermissions.includes(permission));
    }
    return true;
};

export const checkAccess = (permissions: RouteType['permissions'], currentUserPermissions: GetInitInfoQuery['employeePermissions']) => {
    if (!permissions) {
        return true;
    }
    const hasBackofficePermissions = checkScopePermissions(permissions.backoffice, currentUserPermissions.backoffice);
    const hasWarehousePermissions = checkScopePermissions(permissions.warehouse, currentUserPermissions.warehouse);

    return (hasBackofficePermissions && hasWarehousePermissions);
};

export const checkVenueTypeAccess = (allowedVenueTypes?: Array<VenueType>, currentVenueType?: VenueType) =>
// TODO: fallback until new token is issued, removeo onve everyone has new token
    !currentVenueType ||
    (currentVenueType && (
        !allowedVenueTypes || (allowedVenueTypes && allowedVenueTypes.includes(currentVenueType))));